'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard';

import { Button, Card, Icon } from '@benzinga/core-ui';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
const CopyToClipboard = ReactCopyToClipboard as any;

export interface PlanProps {
  className?: string;
  name?: string;
  children?: any;
  isLoading?: boolean;
  onGetStarted?: () => void;
  apiKey?: string;
}

export const Plan: React.FC<PlanProps> = ({ apiKey, children, className = '', isLoading, name, onGetStarted }) => {
  const [didCopy, setDidCopy] = React.useState<boolean>(false);

  const handleOnCopy = React.useCallback(() => {
    setDidCopy(true);
    setTimeout(() => setDidCopy(false), 2000);
  }, []);

  return (
    <PlanContainer className={`plan ${className}`}>
      <h3 className="plan-header">{name}</h3>
      {!apiKey && onGetStarted && (
        <Button className="plan-button" isLoading={isLoading} onClick={onGetStarted} variant="primary">
          Get Started
        </Button>
      )}
      <div>
        <small>
          <b>For Individual Use</b>
        </small>
      </div>
      {children}
      {(apiKey || isLoading) && (
        <div className="api-token-container">
          <div className="label">API Token:</div>
          <div className="value">
            {isLoading ? 'Loading api token...' : apiKey}
            {!isLoading && apiKey && (
              <CopyToClipboard onCopy={handleOnCopy} text={apiKey}>
                <span>{didCopy ? 'Copied' : 'Copy'}</span>
              </CopyToClipboard>
            )}
          </div>
        </div>
      )}
    </PlanContainer>
  );
};

export const FreeTier: React.FC<PlanProps> = props => (
  <Plan name="Basic (Free)" {...props}>
    {FreeTierDetails}
  </Plan>
);

export const LimitedTier: React.FC<PlanProps> = props => (
  <Plan name="Starter" {...props}>
    {LimitedTierDetails}
  </Plan>
);

const PlanContainer = styled(Card)`
  max-width: 300px;
  h3 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  .plan-button {
    margin-bottom: 0.5rem;
  }
  ul {
    .check {
      padding: 0.2rem;
      color: ${({ theme }) => theme.colors.brand};
    }
    li {
      display: flex;
    }
  }
  .sub-details {
    list-style: disc;
    font-size: 0.8rem;
    margin-left: 1.5rem;
    li {
      display: list-item;
    }
  }
  .api-token-container {
    .label {
      font-size: 0.9rem;
      font-weight: bold;
      margin-top: 1rem;
    }
    .value {
      padding: 0.25rem 0.5rem;
      border-radius: 4px;
      border: solid 1px #ddd;
      position: relative;
      display: flex;
      overflow: hidden;
      align-items: center;
      span {
        position: absolute;
        right: 0.1rem;
        background-color: white;
        padding: 0rem 0.4rem;
        border-radius: 4px;
        border: solid 1px #ddd;
        cursor: pointer;
      }
    }
  }
`;

const FreeTierDetails = (
  <ul className="plan-details">
    <li>
      <div className="check">
        <Icon icon={faCheck} />
      </div>
      <div>Delayed Newsfeed</div>
    </li>
    <li>
      <div className="check">
        <Icon icon={faCheck} />
      </div>
      <div>
        <div>Calendar Data</div>
        <ul className="sub-details">
          <li>Dow 30 coverage</li>
          <li>1 mo. data</li>
          <li>1 day delay</li>
        </ul>
      </div>
    </li>
  </ul>
);

const LimitedTierDetails = (
  <ul className="plan-details">
    <li>
      <div className="check">
        <Icon icon={faCheck} />
      </div>
      <div>Delayed Newsfeed</div>
    </li>
    <li>
      <div className="check">
        <Icon icon={faCheck} />
      </div>
      <div>
        <div>Calendar Data</div>
        <ul className="sub-details">
          <li>Delayed data</li>
          <li>1 year historical limit</li>
        </ul>
      </div>
    </li>
  </ul>
);

export default Plan;
